<template>
  <v-container class=" pa-1 pa-sm-4" fluid>
    <!-- Options -->
    <v-row>
      <v-col sm="12" md="9" class="pt-0 pb-0">
        <v-row>
          <v-col cols="6">
            <v-combobox
              v-if="!isShowAddOne"
              :label="lable2"
              v-model="optionSelected"
              :items="[{ text: '暫無資料', value: -1 }]"
            ></v-combobox>
            <v-combobox
              v-else
              :label="lable2"
              v-model="optionSelected"
              @change="handleOnChangeOption"
              :items="addthreeslist"
            ></v-combobox>
          </v-col>
          <v-col cols="6">
            <v-combobox
              v-if="!isShowAddOne"
              :label="lable3"
              v-model="optionSelected2"
              :items="[{ text: '暫無資料', value: -1 }]"
            ></v-combobox>
            <v-combobox
              v-else
              :label="lable3"
              v-model="optionSelected2"
              @change="handleOnChangeOption2"
              :items="listByOption"
            ></v-combobox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12">
        <v-combobox
          v-if="!isShowAddOne"
          :label="lable3"
          v-model="optionSelected2"
          :items="[{ text: '暫無資料', value: -1 }]"
        ></v-combobox>
        <v-combobox
          v-else
          :label="lable3"
          v-model="optionSelected2"
          @change="handleOnChangeOption2"
          :items="listByOption"
        ></v-combobox>
      </v-col>
    </v-row> -->
    <!-- Save & Delete Buttons -->
    <v-row>
      <v-col sm="12" md="9" class="pb-0 pt-0 text-end">
        <v-btn
          class="ma-2"
          elevation="4"
          color="primary"
          @click="handleOnNewAddOne"
        >
          <v-icon>mdi-plus-thick</v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          elevation="4"
          color="error"
          @click="handleOnDeleteAddOne"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- List -->
    <v-row>
      <v-col sm="12" md="9">
        <v-card>
          <v-list v-if="!isShowAddOne || visiblePages.length < 1" disabled>
            <v-subheader
              ><h2>{{ lable1 }}</h2></v-subheader
            >
            <v-list-item-group>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="`${isSending ? '資料更新中...' : '暫無資料'}`"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list v-else>
            <v-subheader
              ><h2>{{ lable1 }}</h2></v-subheader
            >
            <v-list-item v-for="(item, i) in visiblePages" :key="i">
              <v-list-item-action>
                <v-checkbox
                  :value="item.id"
                  v-model="checkboxSelected"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn elevation="4" @click="handleOnEditAddOne(item)" icon>
                  <v-icon color="gray">mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="9">
        <v-pagination
          @input="checkboxSelected = []"
          v-model="page"
          :length="Math.ceil(list2ByOption.length / perPage)"
        ></v-pagination>
      </v-col>
    </v-row>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3>{{ dialogTitle }}</h3>
        </v-card-title>
        <v-card-text>
          <v-form v-model="dialogInputValid" @submit.prevent="">
            <v-text-field
              v-model="addone"
              :label="dialogInputLabel"
              :rules="addoneRules"
              :counter="10"
              required
            >
            </v-text-field>
            <v-switch
              v-model="addoneEnb"
              inset
              color="primary"
              :label="`狀態:${addoneEnb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn elevation="4" color="error" @click="dialog = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-progress-linear
          :active="isSending"
          indeterminate
          absolute
          bottom
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    lable2: '零組件類別',
    lable3: '零組件品牌',
    lable1: '零組件系列',
    addone: '',
    addoneListLabel: '暫無資料',
    addoneEnb: false,
    addoneRules: [
      v => !!v || '不可空白',
      v => v.length <= 10 || '字數不可超過10個字'
    ],
    isShowAddOne: false,
    perPage: 5,
    page: 1,
    checkboxSelected: [],
    dialog: false,
    dialogTitle: '新增系列',
    dialogInputLabel: '',
    dialogOnSaveFn: undefined,
    dialogInputValid: false,
    //
    optionSelected: [],
    optionSelected2: [],
    //
    nothing: undefined
  }),
  computed: {
    ...mapState('account', ['uid']),
    ...mapState('admin', [
      'addthrees',
      'addthreeslist',
      'addthreeslist2',
      'isSending'
    ]),
    listByOption() {
      const out = []
      if (!this.optionSelected.value) return out
      const l_id = this.optionSelected.value
      this.addthreeslist2.forEach(e => {
        if (e.l_id === l_id) out.push(e)
      })
      return out
    },
    list2ByOption() {
      const out = []
      if (!this.optionSelected2.value) return out
      const b_id = this.optionSelected2.value
      this.addthrees.forEach(e => {
        if (e.b_id === b_id) out.push(e)
      })
      return out
    },
    visiblePages() {
      return this.list2ByOption.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      )
    },
    nothingComputed() {
      return false
    }
  },
  methods: {
    ...mapActions('admin', [
      'getAddThrees',
      'updateAddThrees',
      'saveAddThree',
      'deleteAddThree'
    ]),
    handleOnChangeOption() {
      this.checkboxSelected = []
      this.optionSelected2 = this.listByOption[0]
    },
    handleOnChangeOption2() {
      this.checkboxSelected = []
    },
    handleOnNewAddOne() {
      if (this.optionSelected2.length < 1) return
      if (!this.optionSelected2.text) return
      if (!this.optionSelected2.value) return
      const tempOS = this.optionSelected2
      this.addone = ''
      this.addoneEnb = 1
      this.dialogTitle = `新增${this.optionSelected2.text}系列`
      this.dialogInputLabel = '零組件系列'
      this.addoneListLabel = '資料更新中...'
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        const { addone, uid } = this
        this.isShowAddOne = false
        this.optionSelected2 = []
        await this.saveAddThree({
          addone,
          brand_id: tempOS.value,
          uid,
          enb: this.addoneEnb ? 1 : 0
        })
        this.$nextTick(() => {
          this.optionSelected2 = tempOS
          this.isShowAddOne = true
          this.dialog = false
        })
      }
    },
    handleOnDeleteAddOne() {
      if (this.optionSelected2.length < 1) return
      if (!this.optionSelected2.text) return
      if (!this.optionSelected2.value) return
      if (this.checkboxSelected.length < 1) return
      const tempOS = this.optionSelected2
      let res = confirm('確定刪除嗎?')
      if (!res) return
      // eslint-disable-next-line prettier/prettier
      (async () => {
        const { uid } = this
        this.isShowAddOne = false
        this.addoneListLabel = '資料更新中...'
        this.optionSelected2 = []
        await this.deleteAddThree({ uid, ids: this.checkboxSelected })
        this.$nextTick(() => {
          this.optionSelected2 = tempOS
          this.isShowAddOne = true
        })
      })()
    },
    handleOnEditAddOne(item) {
      if (this.optionSelected2.length < 1) return
      if (!this.optionSelected2.text) return
      if (!this.optionSelected2.value) return
      const tempOS = this.optionSelected2
      this.addone = item.name
      this.addoneEnb = item.enb
      this.dialogTitle = `編輯${tempOS.text}系列`
      this.dialogInputLabel = '零組件系列'
      this.addoneListLabel = '資料更新中...'
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        if (this.addone === item.name && this.addoneEnb * 1 === item.enb) return
        const { addone, uid } = this
        this.isShowAddOne = false
        this.optionSelected2 = []
        await this.updateAddThrees({
          addone,
          id: item.id,
          uid,
          enb: this.addoneEnb ? 1 : 0
        })
        this.$nextTick(() => {
          this.optionSelected2 = tempOS
          this.isShowAddOne = true
          this.dialog = false
        })
      }
    },
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    },
    nothingMethod() {}
  },
  async created() {
    this.addoneListLabel = '資料更新中...'
    this.isShowAddOne = false
    this.optionSelected = []
    this.optionSelected2 = []
    const { uid } = this
    await this.getAddThrees({ uid })
    this.$nextTick(() => {
      this.optionSelected = this.addthreeslist[0] || []
      this.optionSelected2 = this.addthreeslist2[0] || []
      this.isShowAddOne = true
    })
  },
  nothing() {}
}
</script>

<style scoped></style>
